import type { ListTagFilterProps } from "./list-tag-filter.type";

import { FilterFilled } from "@ant-design/icons";
import { useTranslation } from "react-i18next";

import { useListContext } from "@/modules/list";

import { ListTag } from "../list-tag.component";

export const ListTagFilter = ({ filterKey }: ListTagFilterProps) => {
  const { t } = useTranslation();
  const { columnsOptions, clearFilter } = useListContext();

  const column = columnsOptions.find((c) => c.filterKey === filterKey);
  const title = column?.title ?? filterKey;

  return (
    <ListTag
      icon={<FilterFilled />}
      onClose={() => clearFilter(filterKey)}
      closeAriaLabel={t("global:listResetActions.removeFilter")}
    >
      {title}
    </ListTag>
  );
};
